import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar el Rechazo Automático",
    opening: localizedGenderNode(
      [
      "Hoy solo observo — no arreglo."
    ],
      [
      "Hoy solo observo — no arreglo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Algo bueno llegó a mí — y no tengo que empujarlo fuera.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Algo bueno llegó a mí — y no tengo que empujarlo fuera.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cómo suelo responder a un halago o reconocimiento? (lo minimizo / bromeo / cambio de tema)\n[Escribe aquí]",
      "2. ¿Qué siento en el cuerpo cuando alguien dice algo bueno de mí?\n[Escribe aquí]",
      "3. ¿Qué frase interna aparece de inmediato?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cómo suelo responder a un halago o reconocimiento? (lo minimizo / bromeo / cambio de tema)\n[Escribe aquí]",
      "2. ¿Qué siento en el cuerpo cuando alguien dice algo bueno de mí?\n[Escribe aquí]",
      "3. ¿Qué frase interna aparece de inmediato?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi reacción es un hábito — no una verdad.",
      "Pequeña acción de hoy"
    ],
      [
      "Cierre",
      "Mi reacción es un hábito — no una verdad.",
      "Pequeña acción de hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: cuando llegue algo bueno — solo observo lo que pasa dentro de mí.",
      "Una vez hoy: cuando llegue algo bueno — solo observo lo que pasa dentro de mí."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué Da Miedo al Recibir",
    opening: localizedGenderNode(
      [
      "Hoy reviso qué es lo que realmente me asusta al recibir."
    ],
      [
      "Hoy reviso qué es lo que realmente me asusta al recibir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué me asusta de dejar entrar un halago?\n[Escribe aquí]",
      "2. ¿Qué pensamiento aparece justo después? (\"Exageran\", \"No es real\")\n[Escribe aquí]",
      "3. ¿Qué temo que pase si lo creo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué me asusta de dejar entrar un halago?\n[Escribe aquí]",
      "2. ¿Qué pensamiento aparece justo después? (\"Exageran\", \"No es real\")\n[Escribe aquí]",
      "3. ¿Qué temo que pase si lo creo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "A veces el miedo es a exponerse — no al engaño.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "A veces el miedo es a exponerse — no al engaño.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Una respiración + la frase: “Puedo sentir incomodidad.”",
      "Una respiración + la frase: “Puedo sentir incomodidad.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El Hábito de Hacerme Pequeño/a",
    opening: localizedGenderNode(
      [
      "Hoy reconozco la minimización — sin juzgar."
    ],
      [
      "Hoy reconozco la minimización — sin juzgar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué palabras uso para hacerme pequeño/a?\n[Escribe aquí]",
      "2. ¿Dónde aprendí que es “peligroso” destacar?\n[Escribe aquí]",
      "3. ¿De qué intenta protegerme esto?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué palabras uso para hacerme pequeño/a?\n[Escribe aquí]",
      "2. ¿Dónde aprendí que es “peligroso” destacar?\n[Escribe aquí]",
      "3. ¿De qué intenta protegerme esto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Minimizar es una protección antigua.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Minimizar es una protección antigua.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Cuando me minimizo — solo digo: “Lo noté.”",
      "Cuando me minimizo — solo digo: “Lo noté.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Halago ≠ Obligación",
    opening: localizedGenderNode(
      [
      "Hoy separo recibir de presión."
    ],
      [
      "Hoy separo recibir de presión."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué obligación imagino que viene con un halago?\n[Escribe aquí]",
      "2. ¿Un halago realmente me obliga a algo?\n[Escribe aquí]",
      "3. ¿Qué pensamiento calmante es posible?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué obligación imagino que viene con un halago?\n[Escribe aquí]",
      "2. ¿Un halago realmente me obliga a algo?\n[Escribe aquí]",
      "3. ¿Qué pensamiento calmante es posible?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Recibir no exige perfección.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Recibir no exige perfección.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Frase: “Un halago es un momento, no un contrato.”",
      "Frase: “Un halago es un momento, no un contrato.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Logros que Nunca Conté",
    opening: localizedGenderNode(
      [
      "Hoy cuento lo que no tuvo aplausos."
    ],
      [
      "Hoy cuento lo que no tuvo aplausos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Tres cosas que logré — y nunca reconocí\n[Escribe aquí]",
      "2. ¿Por qué las descarté?\n[Escribe aquí]",
      "3. ¿Cómo se siente verlas escritas?\n[Escribe aquí]"
    ],
      [
      "1. Tres cosas que logré — y nunca reconocí\n[Escribe aquí]",
      "2. ¿Por qué las descarté?\n[Escribe aquí]",
      "3. ¿Cómo se siente verlas escritas?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No todo logro necesita público.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "No todo logro necesita público.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Escribo un logro en mi cuaderno — y cierro.",
      "Escribo un logro en mi cuaderno — y cierro."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "“Fue Solo Suerte”",
    opening: localizedGenderNode(
      [
      "Hoy reviso la historia de la suerte."
    ],
      [
      "Hoy reviso la historia de la suerte."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo digo “fue solo suerte”?\n[Escribe aquí]",
      "2. ¿Qué parte mía sí estuvo involucrada?\n[Escribe aquí]",
      "3. ¿Cómo suena un reconocimiento mínimo sin arrogancia?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo digo “fue solo suerte”?\n[Escribe aquí]",
      "2. ¿Qué parte mía sí estuvo involucrada?\n[Escribe aquí]",
      "3. ¿Cómo suena un reconocimiento mínimo sin arrogancia?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Reconocer esfuerzo no es inflarse.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Reconocer esfuerzo no es inflarse.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Una frase: “Hubo algo mío aquí.”",
      "Una frase: “Hubo algo mío aquí.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Experimento: Solo “Gracias”",
    opening: localizedGenderNode(
      [
      "Hoy no explico ni minimizo."
    ],
      [
      "Hoy no explico ni minimizo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué es más difícil — decir “gracias” o quedarme en silencio?\n[Escribe aquí]",
      "2. ¿Qué surge en mí cuando solo digo gracias?\n[Escribe aquí]",
      "3. ¿Qué no pasó a pesar del miedo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué es más difícil — decir “gracias” o quedarme en silencio?\n[Escribe aquí]",
      "2. ¿Qué surge en mí cuando solo digo gracias?\n[Escribe aquí]",
      "3. ¿Qué no pasó a pesar del miedo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La simplicidad puede ser segura.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "La simplicidad puede ser segura.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Un halago → solo “gracias”.",
      "Un halago → solo “gracias”."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Sostener la Incomodidad (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy me quedo con la sensación un minuto."
    ],
      [
      "Hoy me quedo con la sensación un minuto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué sensación aparece cuando recibo algo bueno?\n[Escribe aquí]",
      "2. Práctica de un minuto: dejo que la sensación esté — sin actuar.\n[Escribe aquí]",
      "3. ¿Qué pasó después del minuto?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué sensación aparece cuando recibo algo bueno?\n[Escribe aquí]",
      "2. Práctica de un minuto: dejo que la sensación esté — sin actuar.\n[Escribe aquí]",
      "3. ¿Qué pasó después del minuto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La incomodidad no mata — pasa.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "La incomodidad no mata — pasa.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Un minuto solamente.",
      "Un minuto solamente."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Recibir sin Comparar",
    opening: localizedGenderNode(
      [
      "Hoy recibo sin comparar."
    ],
      [
      "Hoy recibo sin comparar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién comparo este halago?\n[Escribe aquí]",
      "2. ¿Cuál es el costo de esa comparación?\n[Escribe aquí]",
      "3. ¿Cómo se siente quedármelo para mí?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién comparo este halago?\n[Escribe aquí]",
      "2. ¿Cuál es el costo de esa comparación?\n[Escribe aquí]",
      "3. ¿Cómo se siente quedármelo para mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Lo bueno para mí no le quita nada a nadie.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Lo bueno para mí no le quita nada a nadie.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Una pausa de comparación hoy.",
      "Una pausa de comparación hoy."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Valor sin Prueba",
    opening: localizedGenderNode(
      [
      "Hoy reviso quién soy sin demostrar."
    ],
      [
      "Hoy reviso quién soy sin demostrar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué intento demostrar al rechazar halagos?\n[Escribe aquí]",
      "2. ¿Qué pasa si no demuestro nada?\n[Escribe aquí]",
      "3. ¿Qué frase estable elijo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué intento demostrar al rechazar halagos?\n[Escribe aquí]",
      "2. ¿Qué pasa si no demuestro nada?\n[Escribe aquí]",
      "3. ¿Qué frase estable elijo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi valor no depende de defenderme.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Mi valor no depende de defenderme.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Vuelvo a la frase estable una vez.",
      "Vuelvo a la frase estable una vez."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Recibir sin Pedir Perdón",
    opening: localizedGenderNode(
      [
      "Hoy noto disculpas innecesarias."
    ],
      [
      "Hoy noto disculpas innecesarias."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde pido perdón sin necesidad?\n[Escribe aquí]",
      "2. ¿Qué temo que piensen de mí?\n[Escribe aquí]",
      "3. ¿Cómo se ve recibir sin disculparme?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde pido perdón sin necesidad?\n[Escribe aquí]",
      "2. ¿Qué temo que piensen de mí?\n[Escribe aquí]",
      "3. ¿Cómo se ve recibir sin disculparme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Recibir en silencio es madurez.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Recibir en silencio es madurez.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — no pedir perdón.",
      "Una vez hoy — no pedir perdón."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cambiar el Lenguaje Interno",
    opening: localizedGenderNode(
      [
      "Hoy cambio una palabra."
    ],
      [
      "Hoy cambio una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué palabra me digo tras un éxito?\n[Escribe aquí]",
      "2. ¿Cómo suena esa verdad en lenguaje humano?\n[Escribe aquí]",
      "3. ¿Qué palabra nueva elijo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué palabra me digo tras un éxito?\n[Escribe aquí]",
      "2. ¿Cómo suena esa verdad en lenguaje humano?\n[Escribe aquí]",
      "3. ¿Qué palabra nueva elijo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Las palabras construyen hogar.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Las palabras construyen hogar.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Un reemplazo solamente.",
      "Un reemplazo solamente."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Dejar que lo Bueno Permanezca",
    opening: localizedGenderNode(
      [
      "Hoy no borro lo bueno rápido."
    ],
      [
      "Hoy no borro lo bueno rápido."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué pasa en mí cuando dejo lo bueno un momento?\n[Escribe aquí]",
      "2. ¿Qué valor sirve esto en mí?\n[Escribe aquí]",
      "3. ¿Qué me prometo cuando aparece el rechazo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué pasa en mí cuando dejo lo bueno un momento?\n[Escribe aquí]",
      "2. ¿Qué valor sirve esto en mí?\n[Escribe aquí]",
      "3. ¿Qué me prometo cuando aparece el rechazo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Lo bueno puede ser estable.",
      "Pequeña acción"
    ],
      [
      "Cierre",
      "Lo bueno puede ser estable.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Pausar 10 segundos con algo bueno.",
      "Pausar 10 segundos con algo bueno."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre Suave",
    opening: localizedGenderNode(
      [
      "Hoy termino sin cambiar quién soy."
    ],
      [
      "Hoy termino sin cambiar quién soy."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración."
    ],
      [
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué cambió en cómo recibo halagos?\n[Escribe aquí]",
      "2. ¿Qué se siente menos amenazante ahora?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué cambió en cómo recibo halagos?\n[Escribe aquí]",
      "2. ¿Qué se siente menos amenazante ahora?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final",
      "No tengo que empujar lo bueno fuera.",
      "Puedo dejarlo estar.",
      "Me quedo conmigo —",
      "y eso es suficiente.",
      "Pequeña acción"
    ],
      [
      "Cierre final",
      "No tengo que empujar lo bueno fuera.",
      "Puedo dejarlo estar.",
      "Me quedo conmigo —",
      "y eso es suficiente.",
      "Pequeña acción"
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice recibir en calma (respirar / escribir / caminar).",
      "Una acción que simbolice recibir en calma (respirar / escribir / caminar)."
    ),
  },
].map(buildNormalizedDay);

export const difficultyReceivingComplimentsAchievementsBlueprintEs = buildNormalizedPilotBlueprint({
  id: "difficulty_receiving_compliments_achievements_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "difficulty_receiving_compliments_achievements",
  category: "general",
  journeyName: {
    he: "קושי לקבל מחמאות והישגים",
    en: "Difficulty Receiving Compliments and Achievements",
    es: "Dificultad para Recibir Halagos y Logros",
  },
  days,
});

export default difficultyReceivingComplimentsAchievementsBlueprintEs;
